/* ==========================================================================
   framelin · Preise
   Preisrechner, Formattabelle und Live-Zahlen der Seite /pages/preise.

   Woher die Preise kommen: Storefront API, je ein Referenzprodukt pro
   Leistenstufe (Blöcke der Section "framelin · Preisrechner"). Die Seite
   rechnet keinen Preis selbst aus, sie liest die Variantenpreise — es
   steht also nie ein anderer Preis da als im Konfigurator.

   Rechenweg wie in assets/frame-configurator.js (getSizeCategory):
   Falzmaß = Bild (+ Passepartout), Umfang = 2 × (B + H), aufgerundet auf
   die nächste 8-cm-Stufe. Ändert sich dort etwas, hier nachziehen.
   ========================================================================== */
(function () {
  'use strict';

  var cfgNode = document.getElementById('fl-preise-config');
  if (!cfgNode) return;

  var CFG;
  try { CFG = JSON.parse(cfgNode.textContent); } catch (e) { return; }
  var GROUPS = (CFG.groups || []).filter(Boolean);
  if (!GROUPS.length) return;
  GROUPS.forEach(function (g) { g.members = (g.members || []).filter(Boolean); });

  /* ---------- Konstanten (Spiegel des Konfigurators) ---------- */

  var STEPS = [];
  for (var s = 48; s <= 400; s += 8) STEPS.push(s);

  var MAT = {
    thin:     { top: 3.5, bottom: 4,   lr: 3.5 },
    standard: { top: 5.5, bottom: 6,   lr: 5.5 },
    wide:     { top: 8.5, bottom: 9,   lr: 8.5 }
  };
  var MAT_LABEL = { thin: 'schmal', standard: 'Standardbreite', wide: 'breit' };

  var MAX_SIDE = 110;      // längste Seite
  var MAX_BOTH = 90;       // sind beide Seiten länger, gibt es das Format nicht
  var MIN_SIDE = 10;

  var FORMATS = [
    { w: 13,   h: 18,   label: '13 × 18' },
    { w: 21,   h: 29.7, label: '21 × 29,7', note: 'A4' },
    { w: 30,   h: 40,   label: '30 × 40' },
    { w: 40,   h: 50,   label: '40 × 50' },
    { w: 50,   h: 70,   label: '50 × 70' },
    { w: 60,   h: 80,   label: '60 × 80' },
    { w: 70,   h: 100,  label: '70 × 100' }
  ];

  /* Was der Kunde wählt → Shopify-Variantenwerte */
  var ARTS = {
    papier:   { typ: 'Papierarbeit',      scope: 'paper', pps: ['ohne', 'einfach', 'freigestellt', 'schwebend'] },
    foto:     { typ: 'Digitaler Upload',  scope: 'paper', pps: ['ohne', 'einfach', 'freigestellt', 'schwebend'] },
    leinwand: { typ: null,                scope: 'canvas', pps: ['ohne'] },
    objekt:   { typ: 'Objektrahmung',     scope: 'paper', pps: ['hintergrundkarton'] }
  };
  var CANVAS_TYP = {
    aufgespannt: 'Leinwand (aufgespannt)',
    nicht:       'Leinwand (nicht aufgespannt)',
    druck:       'Digitale Leinwand'
  };

  var TABS = [
    { id: 'papier', label: 'Papier & Poster', scope: 'paper', cols: [
      { head: 'Ohne Passepartout',  typ: 'Papierarbeit', pp: 'ohne' },
      { head: 'Mit Passepartout',   typ: 'Papierarbeit', pp: 'einfach' },
      { head: 'Passepartout freigestellt', typ: 'Papierarbeit', pp: 'freigestellt' }
    ] },
    { id: 'foto', label: 'Foto drucken + rahmen', scope: 'paper', cols: [
      { head: 'Ohne Passepartout',  typ: 'Digitaler Upload', pp: 'ohne' },
      { head: 'Mit Passepartout',   typ: 'Digitaler Upload', pp: 'einfach' },
      { head: 'Passepartout freigestellt', typ: 'Digitaler Upload', pp: 'freigestellt' }
    ] },
    { id: 'leinwand', label: 'Leinwand', scope: 'canvas', cols: [
      { head: 'Aufgespannt einsenden',     typ: CANVAS_TYP.aufgespannt, pp: 'ohne' },
      { head: 'Nicht aufgespannt einsenden', typ: CANVAS_TYP.nicht,     pp: 'ohne' },
      { head: 'Leinwanddruck (Datei)',     typ: CANVAS_TYP.druck,       pp: 'ohne' }
    ] },
    { id: 'objekt', label: 'Objekt & schwebend', scope: 'paper', cols: [
      { head: 'Objekt im Rahmen',   typ: 'Objektrahmung',    pp: 'hintergrundkarton' },
      { head: 'Papier schwebend',   typ: 'Papierarbeit',     pp: 'schwebend' },
      { head: 'Foto schwebend',     typ: 'Digitaler Upload', pp: 'schwebend' }
    ] }
  ];

  /* ---------- Hilfen ---------- */

  var nf = new Intl.NumberFormat('de-DE', {
    style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 2
  });
  function eur(x) { return nf.format(x).replace(/\s/g, ' '); }

  function num(n) { return String(Math.round(n * 100) / 100).replace('.', ','); }

  function parseNum(str) {
    var v = parseFloat(String(str || '').replace(',', '.'));
    return isFinite(v) ? v : null;
  }

  function typKey(v) {
    return String(v || '').toLowerCase().replace(/[()]/g, '').replace(/\s+/g, ' ').trim();
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Preisdaten laden ---------- */

  function optValue(node, name) {
    var list = node.selectedOptions || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].name === name) return list[i].value;
    }
    return '';
  }

  function addVariant(idx, node) {
    var typ = typKey(optValue(node, 'Typ'));
    var size = /(\d+)/.exec(optValue(node, 'Größe'));
    var pp = String(optValue(node, 'Passepartout')).toLowerCase().trim();
    var price = parseFloat(node.price && node.price.amount);
    if (!typ || !size || !isFinite(price)) return;
    idx[typ + '|' + size[1] + '|' + pp] = price;
  }

  function loadGroup(g) {
    var idx = {};
    var endpoint = '/api/' + (CFG.api || '2025-10') + '/graphql.json';

    function page(cursor) {
      var query = '{product(handle:' + JSON.stringify(g.handle) + '){variants(first:250'
        + (cursor ? ',after:' + JSON.stringify(cursor) : '')
        + '){pageInfo{hasNextPage endCursor}nodes{price{amount}selectedOptions{name value}}}}}';
      return fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': CFG.token
        },
        body: JSON.stringify({ query: query })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (json) {
          var product = json && json.data && json.data.product;
          if (!product) throw new Error('Produkt nicht gefunden');
          product.variants.nodes.forEach(function (n) { addVariant(idx, n); });
          if (product.variants.pageInfo.hasNextPage) return page(product.variants.pageInfo.endCursor);
        });
    }

    return page(null)
      .then(function () { if (Object.keys(idx).length) g.idx = idx; })
      .catch(function (err) { console.warn('[framelin-preise]', g.handle, err); });
  }

  var dataPromise = null;
  function loadData() {
    if (!dataPromise) {
      dataPromise = Promise.all(GROUPS.map(loadGroup)).then(function () {
        var ok = GROUPS.filter(function (g) { return g.idx; });
        if (!ok.length) throw new Error('Keine Preisdaten');
        return ok;
      });
    }
    return dataPromise;
  }

  /* ---------- Rechnen ---------- */

  function falz(w, h, pp, mat) {
    if (pp === 'ohne') return { w: w, h: h };
    var m = MAT[mat] || MAT.standard;
    return { w: w + 2 * m.lr, h: h + m.top + m.bottom };
  }

  /* → { step, falz, umfang } oder null, wenn über 400 cm */
  function stepFor(w, h, pp, mat) {
    var f = falz(w, h, pp, mat);
    var umfang = Math.round(2 * (f.w + f.h) * 100) / 100;
    for (var i = 0; i < STEPS.length; i++) {
      if (umfang <= STEPS[i]) return { step: STEPS[i], falz: f, umfang: umfang };
    }
    return null;
  }

  function groupsFor(scope, groups) {
    return groups.filter(function (g) { return g.scope === scope; });
  }

  function priceIn(g, typ, pp, step) {
    var v = g.idx[typKey(typ) + '|' + step + '|' + pp];
    return v == null ? null : v;
  }

  function minPrice(groups, scope, typ, pp, w, h, mat) {
    var st = stepFor(w, h, pp, mat);
    if (!st) return null;
    var best = null;
    groupsFor(scope, groups).forEach(function (g) {
      var p = priceIn(g, typ, pp, st.step);
      if (p != null && (best === null || p < best)) best = p;
    });
    return best;
  }

  /* ---------- Rechner ---------- */

  function initCalc(root, groups) {
    var form = {
      art:   $$('input[name="fl-art"]', root),
      sub:   $$('input[name="fl-sub"]', root),
      pp:    $$('input[name="fl-pp"]', root),
      mat:   $$('input[name="fl-mat"]', root),
      w:     $('[data-fl-w]', root),
      h:     $('[data-fl-h]', root)
    };
    var out = $('[data-fl-result]', root);
    var strip = $('[data-fl-strip]', root);
    var stripPrice = $('[data-fl-strip-price]', root);
    var subBox = $('[data-fl-sub]', root);
    var ppStep = $('[data-fl-step-pp]', root);
    var ppLegend = $('[data-fl-pp-legend]', root);
    var ppOptions = $('[data-fl-pp-options]', root);
    var ppHint = $('[data-fl-pp-hint]', root);
    var matBox = $('[data-fl-mat]', root);

    function checked(list) {
      for (var i = 0; i < list.length; i++) if (list[i].checked) return list[i].value;
      return null;
    }
    function setChecked(list, value) {
      list.forEach(function (i) { i.checked = (i.value === value); });
    }

    function state() {
      var art = checked(form.art) || 'papier';
      var def = ARTS[art];
      var pp = checked(form.pp) || 'ohne';
      if (art === 'leinwand') pp = 'ohne';
      else if (art === 'objekt') pp = 'hintergrundkarton';
      else if (def.pps.indexOf(pp) < 0) pp = 'ohne';
      var typ = art === 'leinwand' ? CANVAS_TYP[checked(form.sub) || 'aufgespannt'] : def.typ;
      return {
        art: art, scope: def.scope, typ: typ, pp: pp,
        mat: checked(form.mat) || 'standard',
        w: parseNum(form.w.value), h: parseNum(form.h.value)
      };
    }

    /* Welche Steuerelemente zur Auswahl passen */
    function syncControls(st) {
      subBox.hidden = st.art !== 'leinwand';
      ppStep.hidden = st.art === 'leinwand';
      ppOptions.hidden = st.art === 'objekt';
      ppHint.hidden = st.art !== 'objekt';
      ppLegend.textContent = st.art === 'objekt' ? 'Hintergrundkarton' : 'Passepartout';
      $$('[data-fl-pp-only="foto-papier"]', root).forEach(function (n) {
        n.hidden = !(st.art === 'papier' || st.art === 'foto');
      });
      var needsMat = st.art === 'objekt' || (st.pp !== 'ohne' && st.art !== 'leinwand');
      matBox.hidden = !needsMat;
    }

    function validate(st) {
      if (st.w == null || st.h == null) return 'Gib Breite und Höhe deines Bildes in Zentimetern ein, zum Beispiel 30 und 40.';
      if (st.w < MIN_SIDE || st.h < MIN_SIDE) return 'Kleiner als ' + MIN_SIDE + ' cm rahmen wir nicht.';
      if (st.w > MAX_SIDE || st.h > MAX_SIDE || (st.w > MAX_BOTH && st.h > MAX_BOTH)) {
        return 'Unser größtes Format ist ' + MAX_SIDE + ' × ' + MAX_BOTH + ' cm. Schreib uns, wenn du etwas Größeres hast.';
      }
      return null;
    }

    function deepLink(g, st) {
      var q = [
        'frameType=' + encodeURIComponent(st.typ),
        'ppType=' + encodeURIComponent(st.pp),
        'matWidth=' + encodeURIComponent(st.mat),
        'matColor=naturweiss',
        'width=' + encodeURIComponent(String(Math.round(st.w * 10) / 10)),
        'height=' + encodeURIComponent(String(Math.round(st.h * 10) / 10))
      ].join('&');
      return g.url + '?' + q;
    }

    function membersText(g) {
      var names = (g.members || []).map(function (m) { return m.t; });
      if (!names.length) return g.text || '';
      return names.slice(0, 4).join(', ') + (names.length > 4 ? ' u. a.' : '');
    }

    function message(kind, text, withContact) {
      out.textContent = '';
      var box = el('div', 'fl-res fl-res--' + kind);
      box.appendChild(el('p', 'fl-res__msg', text));
      if (withContact) {
        var a = el('a', 'fl-res__contact', 'support@framelin.de');
        a.href = 'mailto:support@framelin.de';
        box.appendChild(a);
      }
      out.appendChild(box);
      strip.hidden = true;
    }

    function render() {
      var st = state();
      syncControls(st);

      var problem = validate(st);
      if (problem) { message('hint', problem, st.w > MAX_SIDE || st.h > MAX_SIDE); return; }

      var step = stepFor(st.w, st.h, st.pp, st.mat);
      if (!step) {
        message('hint', 'Mit ' + (st.pp === 'ohne' ? 'diesem Format' : 'dem Rand') + ' überschreitet der Rahmen unsere Obergrenze von 400 cm Umfang. '
          + (st.pp === 'ohne' ? '' : 'Probiere ein schmaleres Passepartout oder lass es weg. ') + 'Schreib uns, wir finden eine Lösung:', true);
        return;
      }

      var rows = [];
      groupsFor(st.scope, groups).forEach(function (g) {
        var p = priceIn(g, st.typ, st.pp, step.step);
        if (p != null) rows.push({ g: g, price: p });
      });
      rows.sort(function (a, b) { return a.price - b.price; });

      if (!rows.length) {
        message('hint', 'In dieser Größe gibt es die gewählte Kombination als Standard nicht. '
          + 'Probiere ein kleineres Passepartout oder eine andere Art. Schreib uns, wenn du es genau so brauchst:', true);
        return;
      }

      var low = rows[0].price;
      var high = rows[rows.length - 1].price;
      var ranged = rows.length > 1 && high > low;

      out.textContent = '';
      var box = el('div', 'fl-res');

      box.appendChild(el('p', 'fl-res__eyebrow', 'Dein Preis'));
      var price = el('p', 'fl-res__price');
      if (ranged) price.appendChild(el('span', 'fl-res__from', 'ab '));
      price.appendChild(document.createTextNode(eur(low)));
      box.appendChild(price);
      box.appendChild(el('p', 'fl-res__range',
        (ranged ? 'je nach Leiste bis ' + eur(high) + ' · ' : '') + 'Endpreis inkl. MwSt.'));

      /* Passepartout-Anteil sichtbar machen */
      if ((st.art === 'papier' || st.art === 'foto') && (st.pp === 'einfach' || st.pp === 'freigestellt')) {
        var base = stepFor(st.w, st.h, 'ohne', st.mat);
        var g0 = rows[0].g;
        var p0 = base ? priceIn(g0, st.typ, 'ohne', base.step) : null;
        if (p0 != null && rows[0].price > p0) {
          box.appendChild(el('p', 'fl-res__delta',
            'Davon Passepartout: + ' + eur(rows[0].price - p0) + ' gegenüber der Rahmung ohne.'));
        }
      }

      /* Rechenweg offenlegen */
      var calcText = 'Gerechnet für ' + num(step.falz.w) + ' × ' + num(step.falz.h) + ' cm'
        + (st.pp === 'ohne' ? '' : ' (Bild + ' + (st.art === 'objekt' ? 'Karton' : 'Passepartout') + ', ' + MAT_LABEL[st.mat] + ')')
        + ' → Umfang ' + num(step.umfang) + ' cm, Stufe „bis ' + step.step + ' cm“.';
      box.appendChild(el('p', 'fl-res__calc', calcText));

      /* Zeile je Leistenstufe */
      var list = el('div', 'fl-res__rows');
      rows.forEach(function (r) {
        var a = el('a', 'fl-res__row');
        a.href = deepLink(r.g, st);
        var main = el('span', 'fl-res__rowmain');
        main.appendChild(el('span', 'fl-res__rowname', r.g.label));
        var mem = membersText(r.g);
        if (mem) main.appendChild(el('span', 'fl-res__rowmembers', mem));
        a.appendChild(main);
        a.appendChild(el('span', 'fl-res__rowprice', eur(r.price)));
        a.appendChild(el('span', 'fl-res__rowgo', '→'));
        list.appendChild(a);
      });
      box.appendChild(list);

      /* Versand */
      var free = CFG.freeFrom;
      var ship;
      if (low >= free) ship = 'Versandkostenfrei innerhalb Deutschlands.';
      else if (high >= free) ship = 'Versand ' + eur(CFG.shipFee) + ' — ab ' + eur(free) + ' Bestellwert kostenlos.';
      else ship = 'Dazu Versand ' + eur(CFG.shipFee) + '; ab ' + eur(free) + ' Bestellwert kostenlos.';
      box.appendChild(el('p', 'fl-res__ship', ship));

      var cta = el('a', 'fl-res__cta', 'Mit diesen Maßen gestalten');
      cta.href = deepLink(rows[0].g, st);
      box.appendChild(cta);
      box.appendChild(el('p', 'fl-res__note',
        'Der Konfigurator zeigt dir den verbindlichen Preis für genau deine Auswahl, bevor du bezahlst.'));

      out.appendChild(box);

      strip.hidden = false;
      stripPrice.textContent = (ranged ? 'ab ' : '') + eur(low);
    }

    /* ---------- Ereignisse ---------- */

    var timer = null;
    function later() {
      clearTimeout(timer);
      timer = setTimeout(render, 90);
    }

    form.art.concat(form.sub, form.pp, form.mat).forEach(function (i) {
      i.addEventListener('change', render);
    });
    [form.w, form.h].forEach(function (i) {
      i.addEventListener('input', later);
    });

    $$('[data-fl-format]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        form.w.value = num(parseFloat(btn.getAttribute('data-w')));
        form.h.value = num(parseFloat(btn.getAttribute('data-h')));
        render();
      });
    });

    render();
  }

  /* ---------- Formattabelle ---------- */

  function initTable(root, groups) {
    var tabs = $$('[data-fl-tab]', root);
    var panel = $('[data-fl-tablepanel]', root);
    if (!panel) return;

    function show(id) {
      var tab = TABS.filter(function (t) { return t.id === id; })[0] || TABS[0];
      tabs.forEach(function (b) {
        var on = b.getAttribute('data-fl-tab') === tab.id;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });

      panel.textContent = '';
      var wrap = el('div', 'fl-tbl__scroll');
      var table = el('table', 'fl-tbl');
      var cap = el('caption', 'fl-tbl__cap', tab.label + ': Preise nach Bildgröße');
      table.appendChild(cap);

      var thead = el('thead');
      var hr = el('tr');
      var th0 = el('th', null, 'Bildgröße in cm');
      th0.scope = 'col';
      hr.appendChild(th0);
      tab.cols.forEach(function (c) {
        var th = el('th', null, c.head);
        th.scope = 'col';
        hr.appendChild(th);
      });
      thead.appendChild(hr);
      table.appendChild(thead);

      var tbody = el('tbody');
      FORMATS.forEach(function (f) {
        var tr = el('tr');
        var rh = el('th', null, f.label);
        if (f.note) rh.appendChild(el('span', 'fl-tbl__sub', f.note));
        rh.scope = 'row';
        tr.appendChild(rh);
        tab.cols.forEach(function (c) {
          var p = minPrice(groups, tab.scope, c.typ, c.pp, f.w, f.h, 'standard');
          var td = el('td');
          if (p == null) {
            td.className = 'fl-tbl__na';
            td.textContent = '–';
            td.setAttribute('aria-label', 'in dieser Größe nicht als Standard verfügbar');
          } else {
            td.appendChild(el('span', 'fl-tbl__ab', 'ab '));
            td.appendChild(document.createTextNode(eur(p)));
          }
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      });
      table.appendChild(tbody);
      wrap.appendChild(table);
      panel.appendChild(wrap);
      panel.setAttribute('aria-labelledby', 'fl-tab-' + tab.id);
    }

    tabs.forEach(function (b, i) {
      b.addEventListener('click', function () { show(b.getAttribute('data-fl-tab')); });
      b.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        var next = tabs[(i + dir + tabs.length) % tabs.length];
        next.focus();
        show(next.getAttribute('data-fl-tab'));
      });
    });

    show(TABS[0].id);
  }

  /* ---------- Live-Zahlen im Text ---------- */

  var BINDS = {
    /* günstigster Preis überhaupt */
    startpreis: function (groups) {
      var best = null;
      groups.forEach(function (g) {
        Object.keys(g.idx).forEach(function (k) {
          if (best === null || g.idx[k] < best) best = g.idx[k];
        });
      });
      return best == null ? null : 'ab ' + eur(best);
    },
    /* Passepartout-Aufpreis bei 30 × 40 cm (günstigste Leistenstufe) */
    pp_einfach: function (groups) { return ppDelta(groups, 'einfach'); },
    pp_freigestellt: function (groups) { return ppDelta(groups, 'freigestellt'); },
    /* schwebend bei 30 × 40 cm */
    schwebend: function (groups) {
      var p = minPrice(groups, 'paper', 'Papierarbeit', 'schwebend', 30, 40, 'standard');
      return p == null ? null : 'ab ' + eur(p);
    }
  };

  function ppDelta(groups, pp) {
    var best = null;
    groupsFor('paper', groups).forEach(function (g) {
      var a = stepFor(30, 40, 'ohne', 'standard');
      var b = stepFor(30, 40, pp, 'standard');
      if (!a || !b) return;
      var p0 = priceIn(g, 'Papierarbeit', 'ohne', a.step);
      var p1 = priceIn(g, 'Papierarbeit', pp, b.step);
      if (p0 == null || p1 == null) return;
      var d = p1 - p0;
      if (best === null || d < best) best = d;
    });
    return best == null ? null : '+ ' + eur(best);
  }

  function initBinds(groups) {
    $$('[data-fl-bind]').forEach(function (node) {
      var fn = BINDS[node.getAttribute('data-fl-bind')];
      var text = fn ? fn(groups) : null;
      if (text) node.textContent = text;
    });
  }

  /* ---------- Start ---------- */

  function failed(root) {
    var out = $('[data-fl-result]', root);
    if (out) {
      out.textContent = '';
      var box = el('div', 'fl-res fl-res--hint');
      box.appendChild(el('p', 'fl-res__msg',
        'Die Preise konnten gerade nicht geladen werden. Im Konfigurator siehst du den Preis für dein Bild live.'));
      var a = el('a', 'fl-res__cta', 'Zum Konfigurator');
      a.href = CFG.konfigurator || '/pages/auswahl';
      box.appendChild(a);
      out.appendChild(box);
    }
    var panel = $('[data-fl-tablepanel]', root || document);
    if (panel) {
      panel.textContent = '';
      panel.appendChild(el('p', 'fl-tbl__fail', 'Die Tabelle konnte nicht geladen werden. Den Preis für dein Format zeigt dir der Konfigurator.'));
    }
  }

  function start() {
    var root = $('[data-fl-calc-root]');
    loadData()
      .then(function (groups) {
        initBinds(groups);
        if (root) {
          var calc = $('[data-fl-calc]', root);
          if (calc) initCalc(calc, groups);
          initTable(root, groups);
          root.classList.add('fl-ready');
        }
      })
      .catch(function (err) {
        console.warn('[framelin-preise]', err);
        if (root) failed(root);
      });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
